// is the selected a decimal..
const isDecimalSelection = (value: string, cursorPositon: number): boolean => {
    const dotPosition = value.indexOf('.');
    return dotPosition !== -1 && dotPosition < cursorPositon;
};

export default isDecimalSelection;
